// ./src/config/userRoles.ts
import { OPERATION_RIGHTS } from "./operationRights";


export const USER_ROLES = {
  NO_ROLE: "",
  OWNER: '54dfb3ec-7942-4b65-ba51-5ae62e79c860',
  ADMIN: 'b7a5a5a1-82a5-433e-860d-fb7e7a374ad8', // can do everything except subscription and removal of an account
  DRIVER: 'a1b810ca-6f53-4627-aa5c-d6a1714738d9',
  VIEWER: '69533cd1-5468-4c92-bdfe-fc9025915862',
};

export const USER_ROLE_OPTIONS = [
  {
    value: USER_ROLES.ADMIN,
    label: "Admin",
    disabled: false,
  },
  {
    value: USER_ROLES.DRIVER,
    label: "Driver",
    disabled: false,
  },
  {
    value: USER_ROLES.VIEWER,
    label: "Viewer",
    disabled: false,
  },
] as const;


export const MANAGER_ROLES = [USER_ROLES.OWNER, USER_ROLES.ADMIN];

export const ALL_ROLES = [
  USER_ROLES.OWNER,
  USER_ROLES.ADMIN,
  USER_ROLES.DRIVER,
  USER_ROLES.VIEWER,
];

export const MAIN_ROLES_WHO_CAN_EDIT = [
  USER_ROLES.OWNER,
  USER_ROLES.ADMIN,
];

export const ENTITIES = {

  USER_INVITATIONS: "USER_INVITATIONS",
  USERS: "USERS",
  //
  CARS: "CARS",
  TRAVELS: "TRAVELS",
  EXPENSES: "EXPENSES",
  REFUELS: "EXPENSES",
  CHECKPOINTS: "CHECKPOINTS",
  REPORTS: "REPORTS",
  NOTIFICATIONS: "NOTIFICATIONS",
  EXPENSE_TAGS: "EXPENSE_TAGS",
  UPCOMING_SERVICES: "UPCOMING_SERVICES",
  GLOVEBOX: "GLOVEBOX",
  REVENUE: "REVENUE",
  EXPENSE_SCHEDULES: "EXPENSE_SCHEDULES",
  VEHICLE_FINANCING: "VEHICLE_FINANCING",
  TIRE_SET: "TIRE_SET",
  VEHICLE_TASKS: "VEHICLE_TASKS",
  PARKING_SESSIONS: "PARKING_SESSIONS",
  SAVED_PLACES: "SAVED_PLACES",
};

export const FULL_RIGHTS = [
  OPERATION_RIGHTS.CREATE,
  OPERATION_RIGHTS.UPDATE,
  OPERATION_RIGHTS.REMOVE,
  OPERATION_RIGHTS.PRINT,
  OPERATION_RIGHTS.IMPORT,
  OPERATION_RIGHTS.EXPORT,
];

export const USER_ROLE_RIGHTS_ENTITIES = {
  [USER_ROLES.OWNER]: {
    [ENTITIES.USER_INVITATIONS]: FULL_RIGHTS,
    [ENTITIES.USERS]: FULL_RIGHTS,
    [ENTITIES.CARS]: FULL_RIGHTS,
    [ENTITIES.EXPENSES]: FULL_RIGHTS,
    [ENTITIES.REFUELS]: FULL_RIGHTS,
    [ENTITIES.EXPENSE_TAGS]: FULL_RIGHTS,
    [ENTITIES.CHECKPOINTS]: FULL_RIGHTS,
    [ENTITIES.UPCOMING_SERVICES]: FULL_RIGHTS,
    [ENTITIES.REPORTS]: FULL_RIGHTS,
    [ENTITIES.GLOVEBOX]: FULL_RIGHTS,
    [ENTITIES.REVENUE]: FULL_RIGHTS,
    [ENTITIES.TRAVELS]: FULL_RIGHTS,
    [ENTITIES.EXPENSE_SCHEDULES]: FULL_RIGHTS,
    [ENTITIES.VEHICLE_FINANCING]: FULL_RIGHTS,
    [ENTITIES.TIRE_SET]: FULL_RIGHTS,
    [ENTITIES.VEHICLE_TASKS]: FULL_RIGHTS,
    [ENTITIES.PARKING_SESSIONS]: FULL_RIGHTS,
    [ENTITIES.SAVED_PLACES]: FULL_RIGHTS,
  },
  [USER_ROLES.ADMIN]: {
    [ENTITIES.USER_INVITATIONS]: FULL_RIGHTS,
    [ENTITIES.USERS]: FULL_RIGHTS,
    [ENTITIES.CARS]: FULL_RIGHTS,
    [ENTITIES.EXPENSES]: FULL_RIGHTS,
    [ENTITIES.REFUELS]: FULL_RIGHTS,
    [ENTITIES.EXPENSE_TAGS]: FULL_RIGHTS,
    [ENTITIES.CHECKPOINTS]: FULL_RIGHTS,
    [ENTITIES.UPCOMING_SERVICES]: FULL_RIGHTS,
    [ENTITIES.REPORTS]: FULL_RIGHTS,
    [ENTITIES.GLOVEBOX]: FULL_RIGHTS,
    [ENTITIES.REVENUE]: FULL_RIGHTS,
    [ENTITIES.TRAVELS]: FULL_RIGHTS,
    [ENTITIES.EXPENSE_SCHEDULES]: FULL_RIGHTS,
    [ENTITIES.VEHICLE_FINANCING]: FULL_RIGHTS,
    [ENTITIES.TIRE_SET]: FULL_RIGHTS,
    [ENTITIES.VEHICLE_TASKS]: FULL_RIGHTS,
    [ENTITIES.PARKING_SESSIONS]: FULL_RIGHTS,
    [ENTITIES.SAVED_PLACES]: FULL_RIGHTS,
  },
  [USER_ROLES.DRIVER]: {
    [ENTITIES.USER_INVITATIONS]: [],
    [ENTITIES.USERS]: [],
    [ENTITIES.CARS]: FULL_RIGHTS,
    [ENTITIES.EXPENSES]: FULL_RIGHTS,
    [ENTITIES.REFUELS]: FULL_RIGHTS,
    [ENTITIES.EXPENSE_TAGS]: FULL_RIGHTS,
    [ENTITIES.CHECKPOINTS]: FULL_RIGHTS,
    [ENTITIES.UPCOMING_SERVICES]: FULL_RIGHTS,
    [ENTITIES.REPORTS]: FULL_RIGHTS,
    [ENTITIES.GLOVEBOX]: FULL_RIGHTS,
    [ENTITIES.REVENUE]: FULL_RIGHTS,
    [ENTITIES.TRAVELS]: FULL_RIGHTS,
    [ENTITIES.EXPENSE_SCHEDULES]: FULL_RIGHTS,
    [ENTITIES.VEHICLE_FINANCING]: FULL_RIGHTS,
    [ENTITIES.TIRE_SET]: FULL_RIGHTS,
    [ENTITIES.VEHICLE_TASKS]: FULL_RIGHTS,
    [ENTITIES.PARKING_SESSIONS]: FULL_RIGHTS,
    [ENTITIES.SAVED_PLACES]: FULL_RIGHTS,
  },
  [USER_ROLES.VIEWER]: {
    [ENTITIES.USER_INVITATIONS]: [],
    [ENTITIES.USERS]: [],
    [ENTITIES.CARS]: [],
    [ENTITIES.EXPENSES]: [],
    [ENTITIES.REFUELS]: [],
    [ENTITIES.EXPENSE_TAGS]: [],
    [ENTITIES.CHECKPOINTS]: [],
    [ENTITIES.UPCOMING_SERVICES]: [],
    [ENTITIES.REPORTS]: [],
    [ENTITIES.GLOVEBOX]: [],
    [ENTITIES.REVENUE]: [],
    [ENTITIES.TRAVELS]: [],
    [ENTITIES.EXPENSE_SCHEDULES]: [],
    [ENTITIES.VEHICLE_FINANCING]: [],
    [ENTITIES.TIRE_SET]: [],
    [ENTITIES.VEHICLE_TASKS]: [],
    [ENTITIES.PARKING_SESSIONS]: [],
    [ENTITIES.SAVED_PLACES]: [],
  },
};
